import React from "react";
import ErrorPng from "../assests/wrong.webp";
import ErrorIcon from "../assests/errorIcon.jpg";
import SurveyStatusPage from "../components/question-components/survey-status";

const Error = ({ ErrorMessage }) => {
  return <SurveyStatusPage status="error" />;
};

export default Error;
